import {FormGroup, Validators} from '@angular/forms';

export function setRequiredFields(form: FormGroup, requiredFields: string[]) {
  for (const controlName in form.controls) {

    if (controlName === "CustomerType") {
      continue; // skip because updating this control would cause an infinite loop
    }

    const control = form.controls[controlName];

    if (requiredFields.includes(controlName)) {
      if (!control.hasValidator(Validators.required)) {
        control.addValidators([Validators.required]);
      }
    }
    else {
      control.removeValidators([Validators.required]);
    }

    control.updateValueAndValidity();
  }
}
